/**
 * Token Service
 * Manages Auth0 access token retrieval for the API client
 * Mirrors apps/web's pattern but simpler (no React hook)
 */

type GetAccessTokenFn = () => Promise<string>;

class TokenService {
  private getAccessToken: GetAccessTokenFn | null = null;

  /**
   * Register the Auth0 getAccessTokenSilently function
   */
  register(fn: GetAccessTokenFn): void {
    this.getAccessToken = fn;
  }

  /**
   * Clear the registered token function
   */
  clear(): void {
    this.getAccessToken = null;
  }

  /**
   * Get the current access token
   */
  async getToken(): Promise<string | null> {
    if (!this.getAccessToken) {
      return null;
    }
    try {
      return await this.getAccessToken();
    } catch (err) {
      console.error('[TokenService] Failed to get token:', err);
      return null;
    }
  }
}

export const tokenService = new TokenService();
